// src/stone/icons/LogoWhatsapp.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var LogoWhatsapp = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "m.054 24 1.687-6.163a11.87 11.87 0 0 1-1.588-5.945C.156 5.335 5.493 0 12.05 0c3.182.001 6.17 1.24 8.415 3.488a11.82 11.82 0 0 1 3.481 8.413c-.002 6.557-5.34 11.893-11.896 11.893h-.005c-1.99-.001-3.947-.5-5.685-1.448zm6.598-3.807.361.214a9.9 9.9 0 0 0 5.033 1.378h.004c5.45 0 9.886-4.434 9.888-9.885a9.82 9.82 0 0 0-2.894-6.993 9.82 9.82 0 0 0-6.99-2.898c-5.454 0-9.89 4.434-9.892 9.884a9.86 9.86 0 0 0 1.512 5.26l.235.374-.999 3.648z" }),
      /* @__PURE__ */ jsx("path", { d: "M9.077 6.92c-.242-.579-.487-.5-.67-.51-.172-.008-.37-.01-.569-.01s-.52.074-.792.372c-.273.297-1.04 1.016-1.04 2.479 0 1.462 1.064 2.875 1.213 3.074s2.096 3.2 5.078 4.487c.709.306 1.263.489 1.694.626.713.226 1.36.194 1.873.117.57-.085 1.758-.719 2.006-1.413s.248-1.289.173-1.413c-.074-.124-.272-.198-.57-.347s-1.758-.867-2.03-.967c-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.174.199-.347.223-.644.075-.298-.15-1.255-.463-2.39-1.475-.884-.788-1.481-1.761-1.654-2.059-.174-.297-.019-.458.13-.606.134-.133.297-.347.446-.52.148-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207" })
    ]
  }
);
var LogoWhatsapp_default = LogoWhatsapp;

export {
  LogoWhatsapp_default
};
